import { render } from "./TheFeaturePanels.vue?vue&type=template&id=4832c708&scoped=true"
import script from "./TheFeaturePanels.vue?vue&type=script&lang=js"
export * from "./TheFeaturePanels.vue?vue&type=script&lang=js"

import "./TheFeaturePanels.vue?vue&type=style&index=0&id=4832c708&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4832c708"

export default script